

















































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import numeral from 'numeral';
import uniq from 'lodash/uniq';

import { STORE_KEY, store } from './_store';

import ProductCombobox from '@/components/Controls/ProductCombobox.vue';
import ProductContainerCombobox from '@/components/Controls/ProductContainerCombobox.vue';

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'relatedSouffingList', 'meta', 'equipments', 'equipment'
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, ['addItem', 'removeItem', 'setActiveEquipment'])
  },
  components: {
    ProductCombobox,
    ProductContainerCombobox
  }
})
export default class LinesShufl extends Vue {

  @Prop() documentId!: string;
  @Prop() templates!: string;
  @Prop() type!: string;

  opened: any[] = [];
  public dropFiles = [];
  activeTab = 0;

  FILES_HOST = process.env.VUE_APP_UBIC_SERVER_ADDRESS;

  // items: any[] = [];

  formatNumber(value: any) {
    return numeral(value).format('0,0');
  }

  onDetailToggle(row: any, to: string) {
    if (to == 'open') {
      this.opened = uniq([
        ...this.opened,
        row.id
      ]);
    } else {
      this.opened = uniq(
        this.opened.filter(($row) => $row.id != row.id)
      );
    }
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    } else {
      this.$store.dispatch(`${STORE_KEY}/reset`)
    }
  }

  public mounted() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, {
      documentId: this.documentId,
      type: this.type,
    });
  }

  changeFormValue(index: number, field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      index, field, newValue: value
    });
  }

  saving: boolean = false;

  setTab(tab: any) {
    this.activeTab = tab
  }

  saveFormData() {
    this.saving = true;
    // if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`)
        .then((result) => {
          this.$buefy.snackbar.open(`Данные успешно сохранены`);
          // this.$v.form.$reset();
          this.saving = false;
        })
        .catch((e) => {
          console.log(e)
          this.$buefy.snackbar.open({
            type: 'is-warning',
            message: `При сохранении возникли проблемы. Попробуйте позже.`
          })
        })
    // }

  }

}

